(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return "\u00a3" + (cents / 100).toFixed(2);
  }

  function humanizeFrequency(planName) {
    var lower = (planName || "").toLowerCase();
    if (/week/.test(lower)) return "Weekly";
    if (/fortnight|2\s*week/.test(lower)) return "Fortnightly";
    if (/month/.test(lower)) return "Monthly";
    if (/year|annual/.test(lower)) return "Yearly";
    return planName;
  }

  function humanizePeriod(planName) {
    var lower = (planName || "").toLowerCase();
    if (/week/.test(lower)) return "weekly";
    if (/fortnight|2\s*week/.test(lower)) return "fortnightly";
    if (/month/.test(lower)) return "monthly";
    if (/year|annual/.test(lower)) return "yearly";
    return lower;
  }

  function initSubscribeSection(sectionEl) {
    var form = sectionEl.querySelector("[data-subscribe-form]");
    if (!form) return;

    var packs = form.querySelectorAll("[data-subscribe-pack]");
    var freqsContainer = form.querySelector("[data-subscribe-freqs-container]");
    var savingsBlock = form.querySelector("[data-subscribe-savings]");
    var flavoursRoot = form.querySelector("[data-box-flavours]");
    var cta = form.querySelector("[data-subscribe-cta]");
    var savingsValue = form.querySelector("[data-subscribe-savings-value]");
    var savingsText = form.querySelector("[data-subscribe-savings-text]");
    var errorEl = form.querySelector("[data-subscribe-error]");

    var state = {
      variantId: "",
      packSize: 4,
      priceCents: 0,
      discount: 0,
      period: "",
      sellingPlans: [],
      planMatch: "",
      planId: "",
    };

    function setActive(items, activeItem, className) {
      items.forEach(function (item) {
        var isActive = item === activeItem;
        item.classList.toggle(className, isActive);
        item.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function parsePlans(packEl) {
      var raw = packEl.getAttribute("data-selling-plans");
      if (!raw) return [];
      try {
        return JSON.parse(raw);
      } catch (e) {
        return [];
      }
    }

    function renderFreqButtons() {
      if (!freqsContainer) return;
      freqsContainer.innerHTML = "";
      var plans = state.sellingPlans || [];

      if (plans.length === 0) {
        if (savingsBlock) savingsBlock.hidden = true;
        return;
      }

      plans.forEach(function (plan, idx) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "subscribe__freq" + (idx === plans.length - 1 ? " subscribe__freq--active" : "");
        btn.setAttribute("data-subscribe-freq", "");
        btn.setAttribute("data-discount", plan.discount || 0);
        btn.setAttribute("data-period", humanizePeriod(plan.name));
        btn.setAttribute("data-plan-match", plan.name);
        btn.setAttribute("data-plan-id", plan.id);
        btn.setAttribute("aria-pressed", idx === plans.length - 1 ? "true" : "false");

        var radio = document.createElement("span");
        radio.className = "subscribe__freq-radio";
        radio.setAttribute("aria-hidden", "true");
        btn.appendChild(radio);

        var label = document.createElement("span");
        label.className = "subscribe__freq-label";
        label.textContent = humanizeFrequency(plan.name);
        btn.appendChild(label);

        if (plan.discount && plan.discount > 0 && plan.discountType === "percentage") {
          var badge = document.createElement("span");
          badge.className = "subscribe__freq-badge";
          badge.textContent = "Save " + plan.discount + "%";
          btn.appendChild(badge);
        }

        btn.addEventListener("click", function () {
          if (btn.classList.contains("subscribe__freq--active")) return;
          setActive(
            freqsContainer.querySelectorAll("[data-subscribe-freq]"),
            btn,
            "subscribe__freq--active"
          );
          applyFreq(btn);
        });

        freqsContainer.appendChild(btn);
      });

      var activeBtn = freqsContainer.querySelector(".subscribe__freq--active");
      if (activeBtn) {
        applyFreq(activeBtn);
      }

      if (savingsBlock) savingsBlock.hidden = false;
    }

    function applyPack(packEl) {
      state.variantId = packEl.getAttribute("data-variant-id") || "";
      state.packSize = parseInt(packEl.getAttribute("data-pack-size"), 10) || 4;
      state.priceCents = parseInt(packEl.getAttribute("data-price-cents"), 10) || 0;
      state.sellingPlans = parsePlans(packEl);

      if (flavoursRoot) {
        flavoursRoot.dataset.limit = String(state.packSize);
        window.HappyJoBoxFlavours.reset(flavoursRoot);
      }

      renderFreqButtons();
    }

    function applyFreq(freqEl) {
      state.discount = parseInt(freqEl.getAttribute("data-discount"), 10) || 0;
      state.period = freqEl.getAttribute("data-period") || "";
      state.planMatch = freqEl.getAttribute("data-plan-match") || state.period;
      state.planId = freqEl.getAttribute("data-plan-id") || "";
      updateUI();
    }

    function getDiscountedPrice() {
      if (state.discount > 0 && state.priceCents > 0) {
        return Math.round(state.priceCents * (1 - state.discount / 100));
      }
      return state.priceCents;
    }

    function updateSavings() {
      if (savingsValue) savingsValue.textContent = state.discount + "%";
      if (savingsText) {
        savingsText.textContent =
          "saved on every delivery with your " + state.period + " subscription";
      }
    }

    function updateCta() {
      if (!cta) return;

      var isComplete = flavoursRoot
        ? window.HappyJoBoxFlavours.getTotal(flavoursRoot) === state.packSize
        : false;

      var displayPrice = getDiscountedPrice();
      cta.textContent = formatMoney(displayPrice) + " | Subscribe & Save";
      cta.classList.toggle("subscribe__cta--disabled", !isComplete);
      cta.setAttribute("aria-disabled", isComplete ? "false" : "true");
    }

    function updateUI() {
      updateSavings();
      updateCta();
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || "";
      errorEl.hidden = !message;
    }

    packs.forEach(function (pack) {
      pack.addEventListener("click", function () {
        if (pack.classList.contains("subscribe__pack--active")) return;
        setActive(packs, pack, "subscribe__pack--active");
        applyPack(pack);
      });
    });

    if (flavoursRoot) {
      flavoursRoot.addEventListener("box:change", updateUI);
    }

    if (cta) {
      cta.addEventListener("click", function (event) {
        event.preventDefault();
        showError("");

        if (cta.classList.contains("subscribe__cta--disabled")) return;

        var properties = window.HappyJoBoxCart.buildFlavorProperties(
          window.HappyJoBoxCart.getFlavorInputs(flavoursRoot, ".subscribe__qty-input"),
          function (input) { return input.value; },
          function (input) { return input.getAttribute("data-flavour-name"); }
        );

        var sellingPlanId;
        if (state.planId) {
          sellingPlanId = state.planId;
        } else if (window.HappyJoBoxCart && window.HappyJoBoxCart.findSellingPlanId) {
          sellingPlanId = window.HappyJoBoxCart.findSellingPlanId(
            state.sellingPlans,
            state.planMatch
          );
        }

        cta.classList.add("subscribe__cta--loading");
        cta.setAttribute("aria-disabled", "true");

        window.HappyJoBoxCart
          .addPackToCart({
            variantId: state.variantId,
            quantity: 1,
            properties: properties,
            sellingPlanId: sellingPlanId || undefined,
          })
          .then(function () {
            if (window.HappyJoCartDrawer && window.HappyJoCartDrawer.isEnabled()) {
              return window.HappyJoCartDrawer.openAfterAdd();
            }
            window.location.href = "/cart";
          })
          .catch(function (err) {
            showError(err.message);
          })
          .finally(function () {
            cta.classList.remove("subscribe__cta--loading");
            updateCta();
          });
      });
    }

    var activePack = form.querySelector(".subscribe__pack--active") || packs[0];
    if (activePack) {
      setActive(packs, activePack, "subscribe__pack--active");
      state.variantId = activePack.getAttribute("data-variant-id") || "";
      state.packSize = parseInt(activePack.getAttribute("data-pack-size"), 10) || 4;
      state.priceCents = parseInt(activePack.getAttribute("data-price-cents"), 10) || 0;
      state.sellingPlans = parsePlans(activePack);
    }

    renderFreqButtons();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-subscribe-section]").forEach(initSubscribeSection);
  });
})();
